export default class ViewPreferenceStorage {

    private static readonly GLOBAL_KEY = "$RentaTask.viewPreference";

    private static getKey(email?: string): string {
        return email
            ? `$RentaTask.${email}.viewPreference`
            : ViewPreferenceStorage.GLOBAL_KEY;
    }

    public static get(email?: string): boolean | null {
        const value = window.localStorage.getItem(this.getKey(email));
        if (value === null) return null;
        return value === "mobile";
    }

    public static set(preferMobile: boolean, email?: string): void {
        const stored = preferMobile ? "mobile" : "desktop";
        window.localStorage.setItem(this.getKey(email), stored);
        if (email) {
            window.localStorage.setItem(ViewPreferenceStorage.GLOBAL_KEY, stored);
        }
    }
}
